"use strict";
exports.__esModule = true;
var LANGUAGE_ICON_TYPES = {
    DEFAULT: {
        label: 'global',
        tooltip: '',
        type: 'global',
    },
    DEVANAGARI: {
        label: 'devanagari',
        tooltip: '',
        type: 'devanagari',
    },
};
exports["default"] = LANGUAGE_ICON_TYPES;
